// src/components/SuperuserDashboard.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { FaArrowLeft, FaSearch, FaCrown, FaUserSlash, FaUserCheck } from 'react-icons/fa';
import '../App.css';

function SuperuserDashboard({ onBack }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  // 1. Scarica TUTTI gli utenti
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const usersList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setUsers(usersList);
      } catch (error) {
        console.error("Errore recupero utenti:", error);
      }
      setLoading(false);
    };
    fetchUsers();
  }, []);

  // 2. Funzione per cambiare il ruolo
  const handleRoleChange = async (userId, newRole) => {
    const confirm = window.confirm(`Sei sicuro di voler cambiare il ruolo in "${newRole}"?`);
    if (!confirm) return;

    try {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, { role: newRole });

      setUsers(users.map(user =>
        user.id === userId ? { ...user, role: newRole } : user
      ));

    } catch (error) {
      console.error("Errore cambio ruolo:", error);
      alert("Errore nell'aggiornamento.");
    }
  };

  // 3. NUOVA FUNZIONE: Disattiva/Attiva Account
  const handleToggleStatus = async (user) => {
    // Se isDisabled è true (o undefined/false), invertiamo il valore
    const currentStatus = user.isDisabled || false;
    const newStatus = !currentStatus;

    const actionText = newStatus ? "DISATTIVARE" : "RIATTIVARE";

    const confirm = window.confirm(`Sei sicuro di voler ${actionText} l'account di ${user.firstName} ${user.lastName}?`);
    if (!confirm) return;

    try {
      const userRef = doc(db, "users", user.id);
      // Aggiorniamo il campo isDisabled nel DB
      await updateDoc(userRef, { isDisabled: newStatus });

      // Aggiorniamo lo stato locale
      setUsers(users.map(u =>
        u.id === user.id ? { ...u, isDisabled: newStatus } : u
      ));

    } catch (error) {
      console.error("Errore cambio stato:", error);
      alert("Errore durante l'operazione.");
    }
  };

  const filteredUsers = users.filter(user =>
    user.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.lastName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{
      
      minHeight: '100vh',
      padding: '20px',
      fontFamily: "'Poppins', sans-serif",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>

      <div className="glass-panel responsive-padding" style={{ width: '95%', maxWidth: '1300px', padding: '40px', borderRadius: '30px', minHeight: '80vh', display: 'flex', flexDirection: 'column', boxSizing: 'border-box' }}>

        {/* HEADER */}
        <div className="responsive-admin-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', flexWrap: 'wrap', gap: '20px' }}>

          <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={onBack}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                background: 'white', padding: '10px 25px', borderRadius: '30px',
                border: 'none', cursor: 'pointer', fontSize: '14px', color: '#222', fontWeight: 'bold',
                boxShadow: '0 4px 10px rgba(0,0,0,0.1)', transition: 'transform 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <FaArrowLeft /> Torna alla Home
            </button>

            <div style={{ textAlign: 'center' }}>
              <h1 style={{ margin: 0, color: '#222', display: 'flex', alignItems: 'center', gap: '10px', fontSize: '24px', justifyContent: 'center' }}>
                <FaCrown color="gold" style={{ filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.3))' }} /> Dashboard Superuser
              </h1>
              <p style={{ margin: 0, fontSize: '14px', color: '#444' }}>Gestione globale ruoli e account</p>
            </div>
          </div>

          {/* BARRA DI RICERCA */}
          <div style={{ position: 'relative', width: '100%', maxWidth: '300px' }}>
            <FaSearch style={{ position: 'absolute', top: '12px', left: '15px', color: '#666' }} />
            <input
              type="text"
              placeholder="Cerca utente..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="modern-input"
              style={{ paddingLeft: '40px', margin: 0, width: '100%', background: 'white', border: 'none', boxShadow: '0 4px 10px rgba(0,0,0,0.05)', boxSizing: 'border-box' }}
            />
          </div>
        </div>

        {/* TABELLA UTENTI */}
        <div style={{ flex: 1, background: 'rgba(255,255,255,0.9)', borderRadius: '20px', boxShadow: 'inset 0 0 20px rgba(0,0,0,0.05)', overflow: 'hidden', overflowX: 'auto', padding: '20px' }}>

          {loading ? <p style={{ textAlign: 'center', marginTop: '50px' }}>Caricamento utenti...</p> : (
            <table className="superuser-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
              <thead style={{ color: '#555', fontSize: '13px', textTransform: 'uppercase' }}>
                <tr>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Utente</th>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Contatti</th>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Ruolo</th>
                  <th style={{ padding: '15px', textAlign: 'center' }}>Stato Account</th>
                  <th style={{ padding: '15px', textAlign: 'left' }}>Cambia Ruolo</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map(user => (
                  <tr key={user.id} style={{
                    background: 'white',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                    borderRadius: '10px',
                    opacity: user.isDisabled ? 0.6 : 1,
                    transition: 'opacity 0.3s'
                  }}>

                    {/* Nome */}
                    <td data-label="Utente" style={{ padding: '15px', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', background: 'white' }}>
                      <strong style={{ fontSize: '15px', color: user.isDisabled ? '#888' : '#222' }}>
                        {user.firstName} {user.lastName}
                      </strong><br />
                      <span style={{ fontSize: '11px', color: '#888', fontFamily: 'monospace' }}>ID: {user.id.substring(0, 6)}...</span>
                      {user.isDisabled && <span style={{ display: 'inline-block', marginLeft: '5px', fontSize: '10px', background: '#dc3545', color: 'white', padding: '2px 6px', borderRadius: '4px' }}>BLOCCATO</span>}
                    </td>

                    {/* Contatti */}
                    <td data-label="Contatti" style={{ padding: '15px', background: 'white' }}>
                      <div style={{ fontSize: '14px', color: '#333' }}>{user.email}</div>
                      <div style={{ fontSize: '12px', color: '#666' }}>{user.phone}</div>
                    </td>

                    {/* RUOLO ATTUALE */}
                    <td data-label="Ruolo" style={{ padding: '15px', background: 'white' }}>
                      <span style={{
                        background: user.role === 'superuser' ? '#222' : (user.role === 'admin' ? '#fff3cd' : '#e8f5e9'),
                        color: user.role === 'superuser' ? '#FFD700' : (user.role === 'admin' ? '#856404' : '#155724'),
                        padding: '6px 15px', borderRadius: '30px', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase',
                        border: user.role === 'superuser' ? '1px solid #FFD700' : 'none',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                        display: 'inline-block'
                      }}>
                        {user.role || 'utente'}
                      </span>
                    </td>

                    {/* AZIONE STATO (Attiva/Disattiva) */}
                    <td data-label="Stato Account" style={{ padding: '15px', background: 'white', textAlign: 'center' }}>
                      <button
                        onClick={() => handleToggleStatus(user)}
                        style={{
                          background: user.isDisabled ? '#28a745' : '#fff',
                          color: user.isDisabled ? 'white' : '#dc3545',
                          border: user.isDisabled ? 'none' : '1px solid #dc3545',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          fontWeight: 'bold',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          margin: '0 0',
                          transition: 'all 0.2s'
                        }}
                      >
                        {user.isDisabled ? <><FaUserCheck /> Attiva</> : <><FaUserSlash /> Blocca Account</>}
                      </button>
                    </td>

                    {/* AZIONE RUOLO (Select) */}
                    <td data-label="Cambia Ruolo" style={{ padding: '15px', borderTopRightRadius: '10px', borderBottomRightRadius: '10px', background: 'white' }}>
                      <select
                        value={user.role || 'utente'}
                        onChange={(e) => handleRoleChange(user.id, e.target.value)}
                        disabled={user.isDisabled}
                        style={{
                          padding: '8px 12px',
                          borderRadius: '10px',
                          border: '1px solid #ddd',
                          fontFamily: 'Poppins',
                          cursor: user.isDisabled ? 'not-allowed' : 'pointer',
                          background: '#fff',
                          fontSize: '13px',
                          outline: 'none',
                          opacity: user.isDisabled ? 0.5 : 1,
                          width: '100%',
                          maxWidth: '150px'
                        }}
                      >
                        <option value="utente">Utente</option>
                        <option value="admin">Admin</option>
                        <option value="superuser">Superuser</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

      </div>
    </div>
  );
}

export default SuperuserDashboard;